import IMG1 from '../../assets/images/projects_images/project-1.png'
import IMG2 from '../../assets/images/projects_images/project-2.png'
import IMG3 from '../../assets/images/projects_images/project-3.png'
import IMG4 from '../../assets/images/projects_images/project-4.png'
import IMG5 from '../../assets/images/projects_images/project-5.png'
import IMG6 from '../../assets/images/projects_images/project-6.png'
import IMG12 from '../../assets/images/projects_images/project-12.png'
import IMG13 from '../../assets/images/projects_images/project-01.png'
import IMG14 from '../../assets/images/projects_images/Project-02unispace.png'

const personalProjects = [
  {
    id: 4,
    image: IMG4,
    title: 'Brain Tumor MRI Classification',
    description:
      'Developed a CNN model with 98.93% accuracy for classifying brain tumors from MRI images, enhancing diagnostic precision. Utilized a comprehensive dataset of 7023 MRI images. Optimized model architecture and preprocessing for reliable clinical deployment.Accelerated diagnostic efficiency, reducing human error and improving patient outcomes.',
    tools_tech: ['Machine Learning', 'Python', 'keras', 'kaggle'],
    features: [
      'Deep Learning Model',
    ],
    Colab: 'https://colab.research.google.com/drive/1hSjJRvEN5XkfypAgkZOCSWZlpx478OkZ?usp=sharing',
    live: 'https://colab.research.google.com/drive/1hSjJRvEN5XkfypAgkZOCSWZlpx478OkZ?usp=sharing'
  },
  {
    id: 4,
    image: IMG13,
    title: 'UniSpace – Resource Management Platform for Educational Institutes',
    description:
      'Designed & Developed a full-stack web platform to manage resources for colleges and schools.\nImplemented authentication with secure institute and department logins, including registration functionality.\nEngineered department and resource management modules, enabling easy addition, updating, and deletion of resources.\nBuilt an order management system, allowing institutes to track booking history and manage assets.\nIntegrated an analytics dashboard to provide insights into resource utilization, bookings, and revenue.\nOptimized profile management for institutes and departments to update contact details and credentials.',
    tools_tech: ['React.js', 'Tailwind CSS (Frontend)', 'Node.js', 'Express.js (Backend)','MongoDB (Database).'],
    features: [
      'Authentication',
      'Resource Management',
      'Order Management',
      'Analytics Dashboard',
      'Optimized profile management'
    ],
    github: 'https://github.com/code-raj11903/UniSpace-Institute',
    live: 'https://unispace-siw7.onrender.com/'
  },
  {id: 4,
    image: IMG14,
    title: 'UniSpace – Mobile Application for Resource Booking & Payments',
    description:
      'Developed a cross-platform mobile application using Flutter for seamless resource booking and payments.\nImplemented a secure authentication system with login, registration, and profile management.\nBuilt a resource booking system, enabling users to search, filter, and book available resources like labs and parking spaces.\nIntegrated an order management module, allowing users to track order history, view cart items, and complete checkout.\nImplemented payment gateway integration for seamless transactions.\n Structured & Optimized the application with a modular directory structure for easy scalability and maintenance.',
    tools_tech: ['Flutter (Frontend)', 'Dart', 'Firebase','REST API Integration.'],
    features: [
      'Authentication',
      'cross-platform ',
      'Order Management',
      'Resource booking and payments',
      'Optimized profile management'
    ],
    Github: 'https://github.com/code-raj11903/UniSpace-User',
    live: 'https://github.com/code-raj11903/UniSpace-User'
  },
  {
    id: 1,
    image: IMG1,
    title: ' Threadify',
    description:
      ' Utilized MERN stack with Socket.io and Chakra UI, featuring JWT-based authentication, post creation/deletion, like/unlike, comments, follow/unfollow, and account freeze functionalities.Enhanced user experience: Implemented dark/light mode, responsive design, message seen/unseen status,notification sounds, and image support in chats.',
    tools_tech: ['Mern' ,'Socket.io', 'Chakra UI', 'JWT'],
    features: [
      'Responsive',
      'RealTime Chat',
      'Awesome UI Pages',
      'Smooth Scrolling',
      'Dark-Mode',
    ],
    github: 'https://github.com/code-raj11903/SocialMediaThreadsRTC',
    live: 'https://threadify.onrender.com/auth'
  },
  {
    id: 2,
    image: IMG2,
    title: 'JobHive',
    description:
      'Engineered a robust job management system: Enabled employers to post, edit, and delete job listings, significantly enhancing user engagement. Implemented a seamless job application process: Created an intuitive browsing and application system for job seekers.',
    tools_tech: ['React', 'React-Routers', 'NodeJS', 'ExpressJS', 'MongoDB', 'Tailwind CSS', 'JavaScript'],
    features: [
      'Responsive',
      'Multi Page Application',
      'CRUD Operations',
      'Routing with 0 refresh rate',
      'Dark-Mode',
      'Search Feature'
    ],
    github: 'https://github.com/code-raj11903/JobHive',
    live: 'https://jobhive-7f6u.onrender.com/'
  },
  {
    id: 3,
    image: IMG3,
    title: 'EduMinds',
    description:
      ' Designed and Developed: An educational app similar to Udemy, incorporating advanced search algorithms and intuitive design, boosting user acquisition by 50%.',
    tools_tech: ['HTML', 'CSS', 'JavaScript', 'React', 'Redux','Chakra-UI', 'NodeJs', 'ExpressJs', 'MongoDB', 'Chart.js', 
    'Razorpay', 'Nodemailer', 'Redux Toolkit.'],
    features: [
      'Responsive',
      'Deifferent Themes',
      'Dark-Mode',
      'Smooth-transition',
      'Awesome UI Pages',
      'Smooth Scrolling',
      'Email contact form'
    ],
    github: 'https://github.com/code-raj11903/EduMinds',
    live: 'https://github.com/code-raj11903/EduMinds'
  },
  {
    id: 5,
    image: IMG5,
    title: 'Animated E-Commerce ',
    description: '',
    tools_tech: ['HTML', 'Advanced CSS', 'JS', 'Grasp'],
    features: ['Responsive','Dark-Mode',
    'Smooth-transition'],
    github: 'https://github.com/code-raj11903/AnimatedSite',
    live: 'https://code-raj11903.github.io/AnimatedSite/'
  },
  {
    id: 6,
    image: IMG6,
    title: 'Music -My Fav',
    description: 'Spotify Music Player',
    tools_tech: ['HTML', 'CSS', 'JS'],
    github: 'https://github.com/code-raj11903/SpotifyClone-MyFav',
    live: 'https://code-raj11903.github.io/SpotifyClone-MyFav/'
  },
]

const collabProjects = [
  {
    id: 1,
    image: IMG12,
    title: 'Fintrack',
    description:
      'Fintrack ,is an online platform that allows users to manage their finances effectively.',
    tools_tech: ['HTML', 'CSS', 'JavaScript','Local Storage','Netlify'],
    features: ['Responsive', 'Multi Page Application', 'Smooth UI'],
    github: 'https://github.com/code-raj11903/PersonalFinanceTracker',
    live: 'https://getfintrack.netlify.app/'
  },
  
]

export { personalProjects, collabProjects }
